import React from "react";
import Icon from "@/components/icons";
import type { IconTypes } from "@/components/icons/types";

export interface CareerStatProps {
  label: string;
  value: string;
  icon: IconTypes;
  singleLine?: boolean;
  className?: string;
  showIconOnMobile?: boolean;
}

export type CareerStat = Omit<CareerStatProps, "className">;

export default function CareerStat({
  label,
  value,
  icon,
  singleLine = false,
  className,
  showIconOnMobile = false,
}: CareerStatProps) {
  return (
    <div
      className={`bg-white rounded-xl p-4 md:p-6 text-primary flex flex-row items-start ${showIconOnMobile ? "gap-2 md:gap-4" : "gap-4"} ${className || ""}`}
    >
      <div
        className={`${showIconOnMobile ? "flex" : "hidden md:flex"} self-center`}
      >
        <div className="flex items-center justify-center">
          <Icon
            type={icon as IconTypes}
            svgProps={{
              className: "w-10 h-10 lg:w-12 lg:h-12",
            }}
          />
        </div>
      </div>
      <div
        className={`${!showIconOnMobile ? "hidden" : "md:block"} w-px bg-gray-300 self-stretch ${showIconOnMobile ? "mx-1 md:mx-2" : "mx-2"}`}
      ></div>
      <div className="flex-1">
        {singleLine ? (
          <span className="text-md md:text-xl text-gray-700 mb-0">
            {label}{" "}
            <span className="font-bold text-lg md:text-xl">{value}</span>
          </span>
        ) : (
          <>
            <p className="text-lg font-bold text-gray-700 mb-1">{label}</p>
            <p className="text-2xl md:text-xl lg:text-2xl font-bold mb-0">
              {value}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
